import { render, staticRenderFns } from "./title.vue?vue&type=template&id=41c22c6a&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=41c22c6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c22c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c22c6a')) {
      api.createRecord('41c22c6a', component.options)
    } else {
      api.reload('41c22c6a', component.options)
    }
    module.hot.accept("./title.vue?vue&type=template&id=41c22c6a&scoped=true", function () {
      api.rerender('41c22c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/components/title.vue"
export default component.exports